import React, { useEffect } from "react";
import Navbar from "../components/navbar";
import Footer from "../components/footer";
import Switcher from "../components/switcher";
import VideoBackground from "../components/VideoBackground";
import CardBeneficios from "../components/CardBeneficios";
import ba from "../assets/images/sidom/svg/Ar.svg";
import useStore from "../store/useStore";
import BeneficiosDegradeBox from "../components/BeneficiosDegradeBox";
import BarrerasTecnologicas from "../components/BarrerasTecnologicas";
import TestimoniosComex from "../components/TestimoniosComex";
import MisimClientes from "../components/MisimClientes";
import imgI from "../assets/images/icons/arrowI.svg";
import imgD from "../assets/images/icons/arrowD.svg";

import MisimDemoForm from "../components/MisimForm";
import Seo from "../components/Seo";
import SolucionesIntegradas from "../components/SolucionesIntegradas";
import VideoInstitucional from "../components/VideoInstitucional";

const productos = [
  {
    title: "Sin tiempos de conexión y desconexión",
    description:
      "en distintos sistemas centralizando en una única plataforma todas las herramientas de uso diario.",
  },
  {
    title: "Mayor productividad validando y oficializando",
    description:
      "varias destinaciones aduaneras al mismo tiempo, en distintas aduanas y de forma autónoma.",
  },
  {
    title: "Presentaciones automatizadas",
    description: "de documentos o validaciones AFIP desde la plataforma.",
  },
  {
    title: "Acceso en tiempo real a las declaraciones aduaneras",
    description: "a través de nuestra plataforma,  sin límites de usuarios.",
  },
  {
    title: "Visibilidad 360° de todas las operaciones",
    description:
      "Control de operaciones y movimientos desde cualquier dispositivo y lugar.",
  },
  {
    title: "Reportes automáticos personalizables",
    description: "sobre vencimientos, saldos y estados de las operaciones",
  },
];
const features = [
  {
    title: "MRE",
    description:
      "Motor de seguimiento y descargas de importaciones temporales, RAF, reposición de stock con actualización automática de saldos desde ARCA.",
  },
  {
    title: "Nomenclador",
    description: "Incorporado y actualizado con la última normativa.",
  },
  {
    title: "ERP",
    description:
      "Configuración de reglas administrativas con lA, automatiza el 80% del proceso de facturación con el sistema administrativo/contable más moderno del mercado.",
  },
  {
    title: "Connect",
    description:
      "Conectividad al SIM como respaldo, exclusivo para clientes, SIDOM PSVA es el prestador más seguro del mercado con homologación 2019 AFIP.",
  },
  {
    title: "Track",
    description:
      "Reportes de ﻿﻿Seguimiento de estados SIM, ﻿﻿Vencimientos de destinaciones aduaneras y alertas, ﻿﻿Seguimiento de importaciones y exportaciones temporales, Impuestos pagados en línea.",
  },
  {
    title: "PSM",
    description:
      "Confección de operaciones con un PreDespacho predictivo bajo la modalidad OneWindow, mayor agilidad y seguridad, con verificaciones a medida que se ingresa la información.",
  },
  {
    title: "MiSIM",
    description:
      "Único RPA creado para la automatización y eficientización del proceso de declaración aduanera, permite oficializar desde cualquier dispositivo conectado a Internet.",
  },
  {
    title: "Info",
    description:
      "Tipos de cambio e históricos actualizados online; ﻿﻿Entrada de buques a todas las terminales ; ﻿﻿Estados de pasos fronterizos; ﻿﻿Incoterms; ﻿﻿Tipos de contenedores y sus medidas.",
  },
  {
    title: "Drive",
    description: "Almacenamiento de documentación en la nube.",
  },
  {
    title: "MOA",
    description:
      "Consulta en línea del estado de reintegros de exportación, canales, cumplidos, liberación a plaza con interfaz MOA y ARCA.",
  },
  {
    title: "COD",
    description:
      "Presentación masiva de Certificados de Origen Digitales mediante, importación de xml,  obteniendo los acuses de recibo por parte de ARCA.",
  },
];
const handleScrollToSection = () => {
  const el = document.getElementById("section-one");
  if (el) el.scrollIntoView({ behavior: "smooth" });
};
export default function Misim() {
  const {
    misimHeroes,
    getMisimHeroes,
    misimTestimonios,
    fetchMisimTestimonios,
    seoMisims,
    fetchSeoMisims,
  } = useStore();
  const urlApi = process.env.REACT_APP_STRAPI_URL;

  useEffect(() => {
    getMisimHeroes();
    fetchMisimTestimonios();
    fetchSeoMisims();
  }, [getMisimHeroes, fetchMisimTestimonios, fetchSeoMisims]);
  const settings = {
    container: ".tiny-one-item",
    items: features.length === 1 ? 1 : 3, // Mostrar solo una tarjeta si hay una
    center: features.length === 1,
    controls: true,
    mouseDrag: true,
    loop: true, // scroll infinito activado
    animateOut: "rollOut",
    navPosition: "bottom",
    controlsText: [
      `<img src=${imgI} alt="logo_back" class="w-[16px] h-[16px]"/>`,
      `<img src=${imgD} alt="logo_next" class="w-[16px] h-[16px]"/>`,
    ],
    nav: true,

    gutter: 20,
    responsive: {
      0: {
        items: 1,
        gutter: 15,
      },
      480: {
        items: 1,
        gutter: 15,
      },
      640: {
        items: 1,
        gutter: 18,
      },
      768: {
        items: 2,
        gutter: 20,
      },
      1024: {
        items: 2,
        gutter: 25,
      },
      1280: {
        items: 3,
        gutter: 20,
      },
      1536: {
        items: 3,
        gutter: 25,
      },
    },
  };

  return (
    <>
      <Seo
        metaTitle={seoMisims[0]?.metatitle}
        metaDescription={seoMisims[0]?.metadescription}
        metaImage={seoMisims[0]?.metaimage?.url}
        metaKeywords={seoMisims[0]?.metakeywords}
        canonicalURL={seoMisims[0]?.canonicalurl}
      />
      <header>
        <Navbar />
      </header>
      <main className="bg-sidom-light dark:bg-sidom-blue">
        {/* Sección de video de bienvenida */}
        <section aria-label="Video de bienvenida">
          {misimHeroes?.length === 0 || !misimHeroes ? (
            <VideoBackground
              video="/placeholder.mp4"
              titulo1="Cargando..."
              titulo2="Espere un momento"
              textbutton="SOLICITAR DEMO"
              logo="/placeholder-logo.png"
            />
          ) : (
            misimHeroes.map((item, index) => (
              <VideoBackground
                key={index}
                video={`${urlApi}${item.video[0]?.url}`}
                titulo1={item.titulo}
                titulo2={item.text}
                textbutton="¡Quiero probar MiSIM!"
                onButtonClick={handleScrollToSection}
                logo={`${urlApi}${
                  item.img[0]?.formats?.thumbnail?.url ||
                  item.img?.url ||
                  "/placeholder-logo.png"
                }`}
                cartel={
                  <div className="flex flex-row justify-start items-center text-base font-bold text-sidom-light mb-4">
                    <p>Solo disponible en Argentina</p>
                    <div className="rounded-full ">
                      <img
                        src={ba}
                        alt="Bandera de Argentina"
                        className="ml-2 rounded-full w-9 h-9 object-cover border "
                      />
                    </div>
                  </div>
                }
              />
            ))
          )}
        </section>
        {/* Sección de video institucional */}
        <VideoInstitucional />
        {/* Sección de beneficios */}
        <section aria-label="Beneficios de MiSIM">
          <BeneficiosDegradeBox />
        </section>
        {/* Sección de barreras tecnológicas */}
        <section>
          <BarrerasTecnologicas onButtonClick={handleScrollToSection} />
        </section>

        {/* Sección de beneficios detallados */}
        <section className="container mb-[100px]">
          <div className="flex flex-col h-full px-2 md:px-0 lg:px-0">
            <h1 className="text-sidom-orange mt-[70px] md:mt-[100px] lg:mt-[90px]  mb-[60px] text-3xl md:text-[40px] lg:text-[45px] font-extrabold text-left leading-tight">
              Beneficios
            </h1>
            {productos.map((producto, index) => (
              <CardBeneficios
                key={index}
                titulo={producto.title}
                descripcion={producto.description}
              />
            ))}
          </div>
        </section>

        {/* Sección de soluciones integradas */}
        <SolucionesIntegradas features={features} settings={settings} />

        {/* Sección de testimonios */}
        <section aria-label="Testimonios de clientes">
          {misimTestimonios &&
          Array.isArray(misimTestimonios) &&
          misimTestimonios.length > 0 ? (
            <TestimoniosComex
              testimonios={misimTestimonios}
              color={"bg-sidom-light dark:bg-sidom-blue"}
            />
          ) : (
            <p className="text-center text-sidom-dark dark:text-sidom-light py-8">
              No hay testimonios disponibles.
            </p>
          )}
        </section>
        {/* Sección de clientes */}
        <section aria-label="Clientes MiSIM" className=" ">
          <MisimClientes />
        </section>
      </main>
      {/* Sección de formulario de demo */}
      <section id="section-one" aria-label="Formulario de solicitud de demo">
        <MisimDemoForm />
      </section>
      <Switcher />
      <footer>
        <Footer />
      </footer>
    </>
  );
}
